export type IconNameType =
  "user"
  | "map"
  | "user-selected"
  | "map-selected"
  | "settings"
  | "angle-left"
  | "angle-right"
  | "alert-circle"
  | "dollar-sign"
  | "map-pin"
  | "tag"
  | "globe"
  | "phone"
  | "upload"
  | "chevron-down"
  | "check"
  | "check-circle"
  | "warning"
  | "error"
  | "events"
  | "bars-2"
  | "users"
  | "share"
  | "dashboard"
  | "arrow-turn-down-left"
  | "arrow-left"
  | "alert"
  | "arrow-down"
  | "cvc"
  | "x"
  | "heart"
  | "calendar"
  | "star"
  | "star-outline"
  | "heart-outline"
  | "arrow-up-right"
  | "home"
  | "search"


function Icon(props: { name?: IconNameType, className?: string, onClick?: () => void }) {

  const otherProps = {
    ...props
  };

  delete otherProps.name;


  if (props.name === "star") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           strokeWidth={1.5}
           stroke="currentColor"
           fill="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
      </svg>
    );
  }

  if (props.name === "star-outline") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg"
           fill="none"
           viewBox="0 0 24 24"
           strokeWidth={1.5}
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M11.48 3.499a.562.562 0 0 1 1.04 0l2.125 5.111a.563.563 0 0 0 .475.345l5.518.442c.499.04.701.663.321.988l-4.204 3.602a.563.563 0 0 0-.182.557l1.285 5.385a.562.562 0 0 1-.84.61l-4.725-2.885a.562.562 0 0 0-.586 0L6.982 20.54a.562.562 0 0 1-.84-.61l1.285-5.386a.562.562 0 0 0-.182-.557l-4.204-3.602a.562.562 0 0 1 .321-.988l5.518-.442a.563.563 0 0 0 .475-.345L11.48 3.5Z" />
      </svg>
    );
  }


  if (props.name === "calendar") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
           stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5" />
      </svg>
    );
  }


  if (props.name === "home") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25" />
      </svg>
    );
  }


  if (props.name === "bars-2") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 9h16.5m-16.5 6.75h16.5" />
      </svg>

    );
  }

  if (props.name === "arrow-up-right") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
           stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 19.5 15-15m0 0H8.25m11.25 0v11.25" />
      </svg>

    );
  }
  if (props.name === "heart-outline") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
      </svg>

    );
  }

  if (props.name === "heart") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24"
           strokeWidth={1.5}
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M21 8.25c0-2.485-2.099-4.5-4.688-4.5-1.935 0-3.597 1.126-4.312 2.733-.715-1.607-2.377-2.733-4.313-2.733C5.1 3.75 3 5.765 3 8.25c0 7.22 9 12 9 12s9-4.78 9-12Z" />
      </svg>

    );
  }

  if (props.name === "search") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
      </svg>

    );
  }

  if (props.name === "tag") {
    return (
      <svg  {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5}
            stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M9.568 3H5.25A2.25 2.25 0 0 0 3 5.25v4.318c0 .597.237 1.17.659 1.591l9.581 9.581c.699.699 1.78.872 2.607.33a18.095 18.095 0 0 0 5.223-5.223c.542-.827.369-1.908-.33-2.607L11.16 3.66A2.25 2.25 0 0 0 9.568 3Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6 6h.008v.008H6V6Z" />
      </svg>
    );
  }


  if (props.name === "cvc") {
    return (
      <svg  {...otherProps} viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg" fill="currentColor" role="presentation">
        <path opacity=".2" fillRule="evenodd" clipRule="evenodd"
              d="M15.337 4A5.493 5.493 0 0013 8.5c0 1.33.472 2.55 1.257 3.5H4a1 1 0 00-1 1v1a1 1 0 001 1h16a1 1 0 001-1v-.6a5.526 5.526 0 002-1.737V18a2 2 0 01-2 2H3a2 2 0 01-2-2V6a2 2 0 012-2h12.337zm6.707.293c.239.202.46.424.662.663a2.01 2.01 0 00-.662-.663z" />
        <path opacity=".4" fillRule="evenodd" clipRule="evenodd"
              d="M13.6 6a5.477 5.477 0 00-.578 3H1V6h12.6z" />
        <path fillRule="evenodd" clipRule="evenodd"
              d="M18.5 14a5.5 5.5 0 110-11 5.5 5.5 0 010 11zm-2.184-7.779h-.621l-1.516.77v.786l1.202-.628v3.63h.943V6.22h-.008zm1.807.629c.448 0 .762.251.762.613 0 .393-.37.668-.904.668h-.235v.668h.283c.565 0 .95.282.95.691 0 .393-.377.66-.911.66-.393 0-.786-.126-1.194-.37v.786c.44.189.88.291 1.312.291 1.029 0 1.736-.526 1.736-1.288 0-.535-.33-.967-.88-1.14.472-.157.778-.573.778-1.045 0-.738-.652-1.241-1.595-1.241a3.143 3.143 0 00-1.234.267v.77c.378-.212.763-.33 1.132-.33zm3.394 1.713c.574 0 .974.338.974.778 0 .463-.4.785-.974.785-.346 0-.707-.11-1.076-.337v.809c.385.173.778.26 1.163.26.204 0 .392-.032.573-.08a4.313 4.313 0 00.644-2.262l-.015-.33a1.807 1.807 0 00-.967-.252 3 3 0 00-.448.032V6.944h1.132a4.423 4.423 0 00-.362-.723h-1.587v2.475a3.9 3.9 0 01.943-.133z" />
      </svg>
    );
  }

  if (props.name === "arrow-left") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor"
           className="size-6">
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5 3 12m0 0 7.5-7.5M3 12h18" />
      </svg>
    );
  }


  if (props.name === "arrow-turn-down-left") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="m7.49 12-3.75 3.75m0 0 3.75 3.75m-3.75-3.75h16.5V4.499" />
      </svg>

    );
  }

  if (props.name === "arrow-down") {
    return (
      <svg  {...otherProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      >
        <line x1="12" y1="5" x2="12" y2="19"></line>
        <polyline points="19 12 12 19 5 12"></polyline>
      </svg>

    );
  }

  if (props.name === "chevron-down") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor"
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
      </svg>
    );
  }


  if (props.name === "dashboard") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M10.5 6h9.75M10.5 6a1.5 1.5 0 1 1-3 0m3 0a1.5 1.5 0 1 0-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-3.75 0H7.5m9-6h3.75m-3.75 0a1.5 1.5 0 0 1-3 0m3 0a1.5 1.5 0 0 0-3 0m-9.75 0h9.75" />
      </svg>
    );
  }

  if (props.name === "share") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="none" stroke="currentColor"
           strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="18" cy="5" r="3"></circle>
        <circle cx="6" cy="12" r="3"></circle>
        <circle cx="18" cy="19" r="3"></circle>
        <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
        <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
      </svg>
    );
  }

  if (props.name === "warning") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="none" stroke="currentColor"
           strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path
          d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
        <line x1="12" y1="9" x2="12" y2="13"></line>
        <line x1="12" y1="17" x2="12.01" y2="17"></line>
      </svg>

    );
  }


  if (props.name === "check-circle") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
           fill="none" stroke="currentColor"
           strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"
      >
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22 4 12 14.01 9 11.01"></polyline>
      </svg>
    );
  }

  if (props.name === "error") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"
           stroke="currentColor"
           strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    );
  }

  if (props.name === "users") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M15 19.128a9.38 9.38 0 0 0 2.625.372 9.337 9.337 0 0 0 4.121-.952 4.125 4.125 0 0 0-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 0 1 8.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0 1 11.964-3.07M12 6.375a3.375 3.375 0 1 1-6.75 0 3.375 3.375 0 0 1 6.75 0Zm8.25 2.25a2.625 2.625 0 1 1-5.25 0 2.625 2.625 0 0 1 5.25 0Z" />
      </svg>
    );
  }

  if (props.name === "events") {
    return (
      <svg {...otherProps} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
           stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round"
              d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 0 1 2.25-2.25h13.5A2.25 2.25 0 0 1 21 7.5v11.25m-18 0A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75m-18 0v-7.5A2.25 2.25 0 0 1 5.25 9h13.5A2.25 2.25 0 0 1 21 11.25v7.5m-9-6h.008v.008H12v-.008ZM12 15h.008v.008H12V15Zm0 2.25h.008v.008H12v-.008ZM9.75 15h.008v.008H9.75V15Zm0 2.25h.008v.008H9.75v-.008ZM7.5 15h.008v.008H7.5V15Zm0 2.25h.008v.008H7.5v-.008Zm6.75-4.5h.008v.008h-.008v-.008Zm0 2.25h.008v.008h-.008V15Zm0 2.25h.008v.008h-.008v-.008Zm2.25-4.5h.008v.008H16.5v-.008Zm0 2.25h.008v.008H16.5V15Z" />
      </svg>
    );
  }


  if (props.name === "check") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>
    );
  }

  if (props.name === "upload") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M17 8L12 3L7 8" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path d="M12 3V15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>
    );
  }


  if (props.name === "globe") {
    return (
      <svg {...otherProps} viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M8.00065 15.1668C11.6825 15.1668 14.6673 12.1821 14.6673 8.50016C14.6673 4.81826 11.6825 1.8335 8.00065 1.8335C4.31875 1.8335 1.33398 4.81826 1.33398 8.50016C1.33398 12.1821 4.31875 15.1668 8.00065 15.1668Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.33398 8.5H14.6673" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path
          d="M8.00065 1.8335C9.66817 3.65906 10.6158 6.02819 10.6673 8.50016C10.6158 10.9721 9.66817 13.3413 8.00065 15.1668C6.33313 13.3413 5.38548 10.9721 5.33398 8.50016C5.38548 6.02819 6.33313 3.65906 8.00065 1.8335Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }


  if (props.name === "phone") {
    return (
      <svg {...otherProps} viewBox="0 0 16 17" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.6669 11.7802V13.7802C14.6677 13.9659 14.6297 14.1497 14.5553 14.3198C14.4809 14.4899 14.3718 14.6426 14.235 14.7681C14.0982 14.8937 13.9367 14.9892 13.7608 15.0487C13.5849 15.1082 13.3985 15.1303 13.2136 15.1136C11.1622 14.8907 9.19161 14.1897 7.46028 13.0669C5.8495 12.0433 4.48384 10.6777 3.46028 9.06689C2.3336 7.3277 1.63244 5.34756 1.41361 3.28689C1.39695 3.10254 1.41886 2.91673 1.47795 2.74131C1.53703 2.56589 1.63199 2.40469 1.75679 2.26797C1.88159 2.13126 2.03348 2.02203 2.20281 1.94724C2.37213 1.87245 2.55517 1.83374 2.74028 1.83356H4.74028C5.06382 1.83038 5.37748 1.94495 5.62279 2.15592C5.8681 2.36689 6.02833 2.65986 6.07361 2.98023C6.15803 3.62027 6.31458 4.24871 6.54028 4.85356C6.62998 5.09218 6.64939 5.3515 6.59622 5.60081C6.54305 5.85012 6.41952 6.07897 6.24028 6.26023L5.39361 7.10689C6.34265 8.77592 7.72458 10.1579 9.39361 11.1069L10.2403 10.2602C10.4215 10.081 10.6504 9.95746 10.8997 9.90429C11.149 9.85112 11.4083 9.87053 11.6469 9.96023C12.2518 10.1859 12.8802 10.3425 13.5203 10.4269C13.8441 10.4726 14.1399 10.6357 14.3513 10.8852C14.5627 11.1348 14.6751 11.4533 14.6669 11.7802Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  if (props.name === "dollar-sign") {
    return (
      <svg {...otherProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 0.666504V15.3332" stroke="currentColor" strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round" />
        <path
          d="M11.3333 3.3335H6.33333C5.71449 3.3335 5.121 3.57933 4.68342 4.01691C4.24583 4.4545 4 5.04799 4 5.66683C4 6.28567 4.24583 6.87916 4.68342 7.31674C5.121 7.75433 5.71449 8.00016 6.33333 8.00016H9.66667C10.2855 8.00016 10.879 8.246 11.3166 8.68358C11.7542 9.12116 12 9.71466 12 10.3335C12 10.9523 11.7542 11.5458 11.3166 11.9834C10.879 12.421 10.2855 12.6668 9.66667 12.6668H4"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>


    );
  }

  if (props.name === "map-pin") {
    return (
      <svg {...otherProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14 6.6665C14 11.3332 8 15.3332 8 15.3332C8 15.3332 2 11.3332 2 6.6665C2 5.07521 2.63214 3.54908 3.75736 2.42386C4.88258 1.29864 6.4087 0.666504 8 0.666504C9.5913 0.666504 11.1174 1.29864 12.2426 2.42386C13.3679 3.54908 14 5.07521 14 6.6665Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M8 8.6665C9.10457 8.6665 10 7.77107 10 6.6665C10 5.56193 9.10457 4.6665 8 4.6665C6.89543 4.6665 6 5.56193 6 6.6665C6 7.77107 6.89543 8.6665 8 8.6665Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>


    );
  }

  /*
  if (props.name === "calendar") {
    return (
      <svg {...otherProps} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.6667 2.6665H3.33333C2.59695 2.6665 2 3.26346 2 3.99984V13.3332C2 14.0696 2.59695 14.6665 3.33333 14.6665H12.6667C13.403 14.6665 14 14.0696 14 13.3332V3.99984C14 3.26346 13.403 2.6665 12.6667 2.6665Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10.666 1.3335V4.00016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path d="M5.33398 1.3335V4.00016" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path d="M2 6.6665H14" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>

    );
  } */


  if (props.name === "settings") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M19.4 15C19.2669 15.3016 19.2272 15.6362 19.286 15.9606C19.3448 16.285 19.4995 16.5843 19.73 16.82L19.79 16.88C19.976 17.0657 20.1235 17.2863 20.2241 17.5291C20.3248 17.7719 20.3766 18.0322 20.3766 18.295C20.3766 18.5578 20.3248 18.8181 20.2241 19.0609C20.1235 19.3037 19.976 19.5243 19.79 19.71C19.6043 19.896 19.3837 20.0435 19.1409 20.1441C18.8981 20.2448 18.6378 20.2966 18.375 20.2966C18.1122 20.2966 17.8519 20.2448 17.6091 20.1441C17.3663 20.0435 17.1457 19.896 16.96 19.71L16.9 19.65C16.6643 19.4195 16.365 19.2648 16.0406 19.206C15.7162 19.1472 15.3816 19.1869 15.08 19.32C14.7842 19.4468 14.532 19.6572 14.3543 19.9255C14.1766 20.1938 14.0813 20.5082 14.08 20.83V21C14.08 21.5304 13.8693 22.0391 13.4942 22.4142C13.1191 22.7893 12.6104 23 12.08 23C11.5496 23 11.0409 22.7893 10.6658 22.4142C10.2907 22.0391 10.08 21.5304 10.08 21V20.91C10.0723 20.579 9.96512 20.258 9.77251 19.9887C9.5799 19.7194 9.31074 19.5143 9 19.4C8.69838 19.2669 8.36381 19.2272 8.03941 19.286C7.71502 19.3448 7.41568 19.4995 7.18 19.73L7.12 19.79C6.93425 19.976 6.71368 20.1235 6.47088 20.2241C6.22808 20.3248 5.96783 20.3766 5.705 20.3766C5.44217 20.3766 5.18192 20.3248 4.93912 20.2241C4.69632 20.1235 4.47575 19.976 4.29 19.79C4.10405 19.6043 3.95653 19.3837 3.85588 19.1409C3.75523 18.8981 3.70343 18.6378 3.70343 18.375C3.70343 18.1122 3.75523 17.8519 3.85588 17.6091C3.95653 17.3663 4.10405 17.1457 4.29 16.96L4.35 16.9C4.58054 16.6643 4.73519 16.365 4.794 16.0406C4.85282 15.7162 4.81312 15.3816 4.68 15.08C4.55324 14.7842 4.34276 14.532 4.07447 14.3543C3.80618 14.1766 3.49179 14.0813 3.17 14.08H3C2.46957 14.08 1.96086 13.8693 1.58579 13.4942C1.21071 13.1191 1 12.6104 1 12.08C1 11.5496 1.21071 11.0409 1.58579 10.6658C1.96086 10.2907 2.46957 10.08 3 10.08H3.09C3.42099 10.0723 3.742 9.96512 4.0113 9.77251C4.28059 9.5799 4.48572 9.31074 4.6 9C4.73312 8.69838 4.77282 8.36381 4.714 8.03941C4.65519 7.71502 4.50054 7.41568 4.27 7.18L4.21 7.12C4.02405 6.93425 3.87653 6.71368 3.77588 6.47088C3.67523 6.22808 3.62343 5.96783 3.62343 5.705C3.62343 5.44217 3.67523 5.18192 3.77588 4.93912C3.87653 4.69632 4.02405 4.47575 4.21 4.29C4.39575 4.10405 4.61632 3.95653 4.85912 3.85588C5.10192 3.75523 5.36217 3.70343 5.625 3.70343C5.88783 3.70343 6.14808 3.75523 6.39088 3.85588C6.63368 3.95653 6.85425 4.10405 7.04 4.29L7.1 4.35C7.33568 4.58054 7.63502 4.73519 7.95941 4.794C8.28381 4.85282 8.61838 4.81312 8.92 4.68H9C9.29577 4.55324 9.54802 4.34276 9.72569 4.07447C9.90337 3.80618 9.99872 3.49179 10 3.17V3C10 2.46957 10.2107 1.96086 10.5858 1.58579C10.9609 1.21071 11.4696 1 12 1C12.5304 1 13.0391 1.21071 13.4142 1.58579C13.7893 1.96086 14 2.46957 14 3V3.09C14.0013 3.41179 14.0966 3.72618 14.2743 3.99447C14.452 4.26276 14.7042 4.47324 15 4.6C15.3016 4.73312 15.6362 4.77282 15.9606 4.714C16.285 4.65519 16.5843 4.50054 16.82 4.27L16.88 4.21C17.0657 4.02405 17.2863 3.87653 17.5291 3.77588C17.7719 3.67523 18.0322 3.62343 18.295 3.62343C18.5578 3.62343 18.8181 3.67523 19.0609 3.77588C19.3037 3.87653 19.5243 4.02405 19.71 4.21C19.896 4.39575 20.0435 4.61632 20.1441 4.85912C20.2448 5.10192 20.2966 5.36217 20.2966 5.625C20.2966 5.88783 20.2448 6.14808 20.1441 6.39088C20.0435 6.63368 19.896 6.85425 19.71 7.04L19.65 7.1C19.4195 7.33568 19.2648 7.63502 19.206 7.95941C19.1472 8.28381 19.1869 8.61838 19.32 8.92V9C19.4468 9.29577 19.6572 9.54802 19.9255 9.72569C20.1938 9.90337 20.5082 9.99872 20.83 10H21C21.5304 10 22.0391 10.2107 22.4142 10.5858C22.7893 10.9609 23 11.4696 23 12C23 12.5304 22.7893 13.0391 22.4142 13.4142C22.0391 13.7893 21.5304 14 21 14H20.91C20.5882 14.0013 20.2738 14.0966 20.0055 14.2743C19.7372 14.452 19.5268 14.7042 19.4 15Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  if (props.name === "angle-left") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.9998 19.75C14.8078 19.75 14.6157 19.6771 14.4697 19.5301L7.46975 12.5301C7.17675 12.2371 7.17675 11.762 7.46975 11.469L14.4697 4.46902C14.7628 4.17602 15.2378 4.17602 15.5308 4.46902C15.8238 4.76202 15.8238 5.23705 15.5308 5.53005L9.06081 12L15.5308 18.47C15.8238 18.763 15.8238 19.238 15.5308 19.531C15.3838 19.677 15.1918 19.75 14.9998 19.75Z"
          fill="currentColor" />
      </svg>

    );
  }

  if (props.name === "angle-right") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none"
           style={{ transform: "rotateY(180deg)" }}
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.9998 19.75C14.8078 19.75 14.6157 19.6771 14.4697 19.5301L7.46975 12.5301C7.17675 12.2371 7.17675 11.762 7.46975 11.469L14.4697 4.46902C14.7628 4.17602 15.2378 4.17602 15.5308 4.46902C15.8238 4.76202 15.8238 5.23705 15.5308 5.53005L9.06081 12L15.5308 18.47C15.8238 18.763 15.8238 19.238 15.5308 19.531C15.3838 19.677 15.1918 19.75 14.9998 19.75Z"
          fill="currentColor" />
      </svg>

    );
  }


  if (props.name === "alert-circle") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          fill="currentColor" />
        <path d="M12 8V12" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 16H12.01" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }

  if (props.name === "alert") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none"
           xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M12 8V12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path d="M12 16H12.01" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>
    );
  }


  if (props.name === "x") {
    return (
      <svg {...otherProps} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 6L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path d="M6 18L18 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>

    );
  }

  if (props.name === "user") {
    return (
      <svg {...otherProps} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M12.5 11C14.7091 11 16.5 9.20914 16.5 7C16.5 4.79086 14.7091 3 12.5 3C10.2909 3 8.5 4.79086 8.5 7C8.5 9.20914 10.2909 11 12.5 11Z"
          stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>

    );
  }

  if (props.name === "map") {
    return (
      <svg {...otherProps} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.5 6V22L8.5 18L16.5 22L23.5 18V2L16.5 6L8.5 2L1.5 6Z" stroke="currentColor" strokeWidth="1.5"
              strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.5 2V18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
        <path d="M16.5 6V22" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
              strokeLinejoin="round" />
      </svg>

    );
  }

  if (props.name === "user-selected") {
    return (
      <svg {...otherProps} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21"
          fill="#D1FFE1" />
        <path
          d="M20.5 21V19C20.5 17.9391 20.0786 16.9217 19.3284 16.1716C18.5783 15.4214 17.5609 15 16.5 15H8.5C7.43913 15 6.42172 15.4214 5.67157 16.1716C4.92143 16.9217 4.5 17.9391 4.5 19V21"
          stroke="#60EC92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M12.5 11C14.7091 11 16.5 9.20914 16.5 7C16.5 4.79086 14.7091 3 12.5 3C10.2909 3 8.5 4.79086 8.5 7C8.5 9.20914 10.2909 11 12.5 11Z"
          fill="#D1FFE1" stroke="#60EC92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>


    );
  }

  if (props.name === "map-selected") {
    return (
      <svg {...otherProps} viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.25 6V22L8.25 18L16.25 22L23.25 18V2L16.25 6L8.25 2L1.25 6Z" fill="#D1FFE1" stroke="#60EC92"
              strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M8.25 2V18" stroke="#60EC92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M16.25 6V22" stroke="#60EC92" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>


    );
  }

  return (
    <span>Icon {props.name} don&apos;t exist</span>
  );
}

export default Icon;

